import { FC, useEffect, useState } from "react";
import logoImage from "../../images/newHome/logo.86f94e73122a4384fda9.png"
import { NAVIGATION_DEMO_NEW } from "data/navigation";
import NavigationItem from "shared/Navigation/NavigationItem";
import MenuBar from "shared/MenuBar/MenuBar";
import { Link } from "react-router-dom";
import logoutSvg from "../../images/newHome/logout_icon.png"
import ThemeButton from "components/NewHome/ThemeButton";

interface Header4Props {
    className?: string;
}

const Header4: FC<Header4Props> = ({ className = "" }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isLogin, setIsLogin] = useState(0);
    const [email, setEmail] = useState<string>("");
    const [type, setType] = useState("");
    const [name, setName] = useState("");

    useEffect(() => {
        if (
            localStorage.getItem("email") &&
            localStorage.getItem("email") != ""
        ) {
            setIsLogin(1);

            setEmail(localStorage.getItem("email") ?? "");
            setType(localStorage.getItem("type") ?? "");
            setName(localStorage.getItem("name") ?? "");
        }
    }, []);

    const logout = () => {
        if (window.google && window.google.accounts) {
            window.google.accounts.id.disableAutoSelect();
            console.log("User has been logged out");
        }
        let data = new FormData();
        fetch(process.env.REACT_APP_API_URL + "/signout", {
            method: "POST",
            body: data,
        })
            .then((res) =>
                res.json().then((res) => {
                    localStorage.removeItem("email");
                    localStorage.removeItem("type");
                    localStorage.removeItem("name");
                    localStorage.removeItem('token');
                    window.location.href = "/";
                })
            )
            .catch((err) => console.log(err));
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <nav className="nc-header-bg py-[18px] sticky top-0 z-30">
            <div className="container lg:flex items-center justify-between">
                {/* Brand */}
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4 lg:pr-5 xl:pr-10">
                        <Link
                            to="/"
                            onClick={scrollToTop}
                            className={`ttnc-logo inline-block text-primary-6000 focus:outline-none focus:ring-0 ${className}`}
                        >
                            <img
                                src={logoImage}
                                alt="Telcorn Logo"
                                className="max-w-[118px] cursor-pointer"
                            />
                        </Link>

                    </div>

                    {/* Mobile Menu Button */}
                    <div className="flex lg:hidden items-center">
                        {/* <SwitchDarkMode /> */}
                        <div className="px-0.5" />
                        <MenuBar />
                    </div>
                </div>
                {/* Nav Menu */}
                <div
                    className={`w-full ${menuOpen ? "block" : "hidden"
                        } lg:flex lg:items-center xl:items-start items-start lg:justify-between`}
                >
                    <ul className="custom-nav nc-Navigation hidden lg:flex xl:flex-wrap lg:items-center lg:space-x-1 relative">
                        {NAVIGATION_DEMO_NEW.map((item) => (
                            <NavigationItem key={item.id} menuItem={item} />
                        ))}
                    </ul>

                    {/* Auth Buttons */}
                    <div className="flex gap-4 mt-2 lg:mt-0">
                        {isLogin == 0 ? (
                            <>
                                <Link
                                    to="/login"
                                    className={`ttnc-logo inline-block`}
                                >
                                    <ThemeButton
                                        bgColor="bg-transparent"
                                        textColor="text-grayTextColor"
                                        padding="py-2"
                                        size="text-base"
                                        className="font-medium"
                                    >
                                        Log in
                                    </ThemeButton>
                                </Link>
                                <Link
                                    to="/login"
                                    className={`ttnc-logo inline-block`}
                                >
                                    <ThemeButton
                                        bgColor="bg-primaryColor"
                                        textColor="text-white"
                                        padding="px-3 py-2"
                                        size="text-base"
                                        className="font-semibold w-[86px] text-center"
                                    >
                                        Sign up
                                    </ThemeButton>
                                </Link>
                            </>
                        ) : (
                            <>
                                {type == "2" ? (
                                    <ThemeButton
                                        bgColor="bg-transparent"
                                        textColor="text-grayTextColor"
                                        padding="py-1"
                                        size="text-base"
                                        className="font-medium"
                                    >
                                        Business/{name}
                                    </ThemeButton>
                                ) : (
                                    <ThemeButton
                                        bgColor="bg-transparent"
                                        textColor="text-grayTextColor"
                                        padding="py-1"
                                        size="text-base"
                                        className="font-medium"
                                    >
                                        Personal/{name}
                                    </ThemeButton>
                                )}
                                <div className="flex items-center justify-center cursor-pointer" title="logout">
                                    <img className="w-8" src={logoutSvg} alt={logoutSvg} onClick={logout} />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Header4;